import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './styles'

const BigModal = ({ open: isOpenExternal, handleClose, handleOpen, children }) => {
  const [isOpen, setOpen] = useState(isOpenExternal)

  const open = () => {
    setOpen(true)
    handleOpen?.()

    // The following is to prevent scrolling on the body when modal is open
    document.body.classList.add(styles.noScroll)
    document.querySelector('html').classList.add(styles.noScroll)
  }

  const close = () => {
    setOpen(false)
    handleClose?.()

    document.body.classList.remove(styles.noScroll)
    document.querySelector('html').classList.remove(styles.noScroll)
  }

  useEffect(() => {
    if (isOpenExternal) {
      open()
    } else {
      close()
    }
  }, [isOpenExternal])

  return (
    isOpen &&
    createPortal(
      <div className={styles.overlay}>
        <div className={styles.fader} onClick={close}></div>
        <div className={styles.content}>{children({ open, close })}</div>
      </div>,
      document.getElementById('react-modal'),
    )
  )
}

export default BigModal
